import AnchorageStages from "./AnchorageStages.vue";
import {
  getLessNeighborTooth,
  getNextNeighborTooth,
  areAllIncisors,
  areAnyIncisors,
  isIncisorTooth,
  getCanineTooth,
  filterFacesByDirection,
} from "./AnchorageCalculation";
import { mainColor, opposingColor, addSceneLights } from "./AnchorageMode";
import { drawBox, drawLine, drawPoint } from "../draw/draw";
import { calculateDistance3D } from "@/components/geometry/geometry.js";
import { switchStitching } from "@/components/appStart/stitching";
import { getMimeType } from "@/components/reports/ReportsManager.js";
import { getFormattedDate, saveFile } from "@/components/reports/fileMethods";

//#region  Fields
const ANIMATE_STAGE_MS = 3000;
const ANIMATE_STAGE_SEC = ANIMATE_STAGE_MS / 1000;
const anchorageRaycaster = new THREE.Raycaster(
  new THREE.Vector3(),
  new THREE.Vector3(),
  0.1,
  100000
);

let controlsInitialized = false;
let playInterval = null;
let anchorData = null;
let teeth1 = null;
let teeth2 = null;
let allTeeth = null;
let currentSourceType = null;
let videoScene = null;
let videoRecorder = null;
let videoExtension = null;

//#endregion

let mode = {
  name: "",
  currentStageId: 0,
  stages: [
    {
      id: 0,
      name: "Original",
    },
    {
      id: 1,
      name: "Anchorage",
    },
  ],
  isWhite: true,
  isActive: false,
  isPlaying: false,
  // noHighlight: true,
  enterMode: function () {
    enterAnchorageAnimationMode();
  },
  leaveMode: function (saveActiveMode) {
    leaveAnchorageAnimationMode(saveActiveMode);
  },
  mouseMove: function (event) {
    // console.log("anchorageAnimation mouse move");
    return false;
  },
};

function enterAnchorageAnimationMode(
  anchorObj,
  anchorageTeeth1,
  anchorageTeeth2,
  sourceType
) {
  currentSourceType = sourceType;
  anchorData = anchorObj;
  teeth1 = anchorageTeeth1;
  teeth2 = anchorageTeeth2;
  allTeeth = teeth1.concat(teeth2);
  viewer.camera.anchorPosition = vueApp.allTeeth.forEach((tooth) => {
    let mesh = viewer.get_model_mesh(tooth.id);
    mesh.visible = tooth.isVisible;
    if (mesh.visible) {
      if (allTeeth.includes(tooth)) {
        let color = teeth1.includes(tooth) ? mainColor : opposingColor;
        tooth.tempColor = color;
        let material = mesh.originalMaterial
          ? mesh.originalMaterial
          : mesh.material;
        mesh.material = material;
        material.color = new THREE.Color(color);
      } else {
        mesh.material.color = new THREE.Color("#FFFFFF");
      }
    }
  });

  $("#anchorageWizard").modal("hide");
  mode.isWhite = vueApp.isWhite;
  // setTimeout(function () {
  initialiseControls();
  // }, 300);
  mode.isActive = true;
  vueApp.activeMode = mode;
  $("#anchorageStagesDiv").css("display", "block");

  let meshes1 = teeth1.map((t) => viewer.get_model_mesh(t.id));
  let meshes2 = teeth2.map((t) => viewer.get_model_mesh(t.id));

  let areIncisors1 = areAnyIncisors(teeth1);
  let areIncisors2 = areAnyIncisors(teeth2);

  let minDistance1 = Infinity;

  [...teeth1].forEach((tooth) => {
    let mesh = viewer.get_model_mesh(tooth.id);
    let isIncisor = isIncisorTooth(tooth);
    if (isIncisor) {
      let canine = getCanineTooth(tooth);
      if (canine) {
        setIncisorAnchorDistance(tooth, canine);
        if (!teeth1.includes(canine)) {
          teeth1.push(canine);
          allTeeth.push(canine);
        }
      } else {
        mesh.anchorDistance = 0;
      }
    } else {
      if (areIncisors2) {
        let neighborTooth = getLessNeighborTooth(tooth);
        let neighborMesh = viewer.get_model_mesh(neighborTooth.id);
        if (!meshes1.includes(neighborMesh) && !meshes2.includes(neighborMesh))
          meshes2.push(neighborMesh);
      }

      let dist = getMeshMinDistance(mesh, meshes2);
      if (dist < minDistance1) {
        minDistance1 = dist;
      }
    }
  });

  let minDistance2 = Infinity;
  [...teeth2].forEach((tooth) => {
    let mesh = viewer.get_model_mesh(tooth.id);
    let isIncisor = isIncisorTooth(tooth);
    if (isIncisor) {
      let canine = getCanineTooth(tooth);
      if (canine) {
        setIncisorAnchorDistance(tooth, canine);
        if (!teeth2.includes(canine)) {
          teeth2.push(canine);
          allTeeth.push(canine);
        }
      } else {
        mesh.anchorDistance = 0;
      }
    } else {
      if (areIncisors1) {
        let neighborTooth = getLessNeighborTooth(tooth);
        let neighborMesh = viewer.get_model_mesh(neighborTooth.id);
        if (!meshes1.includes(neighborMesh) && !meshes2.includes(neighborMesh))
          meshes1.push(neighborMesh);
      }
      let dist = getMeshMinDistance(mesh, meshes1);
      if (dist < minDistance2) {
        minDistance2 = dist;
      }
    }
  });
  console.log("enterAnchorageAnimationMode", minDistance1, minDistance2);

  allTeeth.forEach((tooth) => {
    let mesh = viewer.get_model_mesh(tooth.id);
    let isFirstGroup = teeth1.includes(tooth);
    let minDistance = isFirstGroup ? minDistance1 : minDistance2;
    //Math.max(minDistance1, minDistance2);

    let scalar =
      minDistance *
      (isFirstGroup ? anchorObj.expectedMove1 : anchorObj.expectedMove2);
    if (mesh.anchorDistance !== undefined) scalar = mesh.anchorDistance;

    let targetPosition = mesh.defaultPosition.clone();
    targetPosition.add(mesh.direction.clone().multiplyScalar(scalar));

    mesh.anchorBasePosition = mesh.position.clone();
    mesh.anchorTargetPosition = targetPosition;

    let x0 = mesh.anchorBasePosition.x;
    let y0 = mesh.anchorBasePosition.y;
    let z0 = mesh.anchorBasePosition.z;

    let x1 = mesh.anchorTargetPosition.x;
    let y1 = mesh.anchorTargetPosition.y;
    let z1 = mesh.anchorTargetPosition.z;

    const positionKF = new THREE.VectorKeyframeTrack(
      ".position",
      [0, 3],
      [x0, y0, z0, x1, y1, z1]
    );
    mesh.anchorageClip = new THREE.AnimationClip(
      "anchorageClip",
      ANIMATE_STAGE_SEC,
      [positionKF]
    );
  });

  vueApp.lookAtPoint({ x: 0, y: 0, z: 0 });
}

function setIncisorAnchorDistance(tooth, canine) {
  let mesh = viewer.get_model_mesh(tooth.id);
  let canineMesh = viewer.get_model_mesh(canine.id);
  let canineNeighbor = getNextNeighborTooth(canine);
  let neighborMesh = viewer.get_model_mesh(canineNeighbor.id);

  let from = canineMesh.position.clone();
  let to = neighborMesh.position.clone();
  to.y = from.y;
  canineMesh.anchorDirection = new THREE.Vector3().subVectors(to, from);
  canineMesh.direction = canineMesh.anchorDirection.clone().normalize();

  let facesObj = filterFacesByDirection(
    canineMesh.allFaces,
    canineMesh.anchorDirection,
    -1
  );
  canineMesh.directFaces = facesObj.filtered;
  canineMesh.restFaces = facesObj.rest;

  let dist = getMeshMinDistance(canineMesh, [neighborMesh]);
  canineMesh.anchorDistance = mesh.anchorDistance = dist;
}

function getFromPoints(mesh) {
  let fromPoints = [];
  for (const face of mesh.directFaces) {
    fromPoints.push(
      face.pointA.clone().add(mesh.position),
      face.pointB.clone().add(mesh.position),
      face.pointC.clone().add(mesh.position)
    );
  }
  return fromPoints;
}

function getMeshMinDistance(mesh, targetMeshes, drawLines) {
  let fromPoints = getFromPoints(mesh);
  let minDistance = Infinity;
  for (const fromPoint of fromPoints) {
    anchorageRaycaster.set(fromPoint, mesh.direction);
    let intersects = anchorageRaycaster.intersectObjects(targetMeshes);
    for (const intersect of intersects) {
      if (drawLines) {
        drawLine(intersect.point, fromPoint);
      }
      let dist = calculateDistance3D(intersect.point, fromPoint);
      if (dist < minDistance) {
        minDistance = dist;
      }
    }
  }
  return minDistance;
}

function initialiseControls() {
  if (!controlsInitialized) {
    const componentInstance = new Vue({
      ...AnchorageStages,
      propsData: { mode: mode },
    });
    const vueContainer = document.createElement("div");
    document.getElementById("main_div").appendChild(vueContainer);
    componentInstance.$mount(vueContainer);

    initMovementVector(
      playSliderChanged,
      "#anchorageSlider",
      true, // horizontal
      0, // min
      1, // max
      0.01, // step
      0
    );

    controlsInitialized = true;
  }
}

function leaveAnchorageAnimationMode(saveActiveMode) {
  console.log("leaveAnchorageAnimationMode");
  switchStitching(currentSourceType);
  $("#anchorageStagesDiv").css("display", "none");
  mode.isPlaying = false;
  switchAnchoragePlay(false);
  applyAnchorageStage(0, false);

  allTeeth.forEach((tooth) => {
    tooth.tempColor = null;
    // let mesh = viewer.get_model_mesh(tooth.id);
    // let basedPos = mesh.anchorBasePosition;
    // mesh.position.set(basedPos.x, basedPos.y, basedPos.z);
  });

  mode.isActive = false;
  vueApp.leaveModes(false, false, false);
  vueApp.restoreClipping();
}

function switchAnchoragePlay(isPlaying) {
  if (mode.isPlaying != isPlaying) {
    mode.isPlaying = isPlaying;
    if (mode.isPlaying) {
      mode.currentStageId = 0;
      updateSliderValue(mode.currentStageId);
      applyAnchorageStage(mode.currentStageId);
      playNextStage();
    }
  }
}

function applyAnchorageStage(stageId, needAnimation) {
  console.log("applyAnchorageStage", stageId);

  let stage = mode.stages.find((x) => x.id === stageId);
  // let originalStage = mode.stages[0];
  if (stage) {
    mode.currentStageId = stageId;

    allTeeth.forEach((tooth) => {
      let mesh = viewer.get_model_mesh(tooth.id);
      let basePos = mesh.anchorBasePosition;
      let anchorPos = basePos.clone();
      let anchorRot = new THREE.Vector3(); // mesh.rotation.clone();

      if (stageId > 0) {
        anchorPos = mesh.anchorTargetPosition;
      }
      // savedPos.z = teeth1.includes(tooth)
      //   ? currentPos.z - minDistance * 0.5
      //   : currentPos.z + minDistance * 0.5;

      if (needAnimation) {
        viewer.animate_model(tooth.id, {
          exact: {
            x: anchorPos.x,
            y: anchorPos.y,
            z: anchorPos.z,
            rotationx: anchorRot.x,
            rotationy: anchorRot.y,
            rotationz: anchorRot.z,
            msec: ANIMATE_STAGE_MS - 50,
          },
        });
      } else {
        mesh.position.set(anchorPos.x, anchorPos.y, anchorPos.z);
      }
    });

    if (needAnimation) {
      setTimeout(() => {
        playNextStage();
      }, ANIMATE_STAGE_MS);
    } else {
      updateSliderValue(stageId);
    }
  } else {
    mode.isPlaying = false;
  }
}

function playNextStage() {
  if (playInterval) {
    clearInterval(playInterval);
    playInterval = null;
  }

  if (mode.isPlaying) {
    let maxId = mode.stages.length - 1;
    let stageId = mode.currentStageId;
    let nextStageId = stageId + 1;

    if (nextStageId <= maxId) {
      applyAnchorageStage(nextStageId, true);
      let counter = 0;
      playInterval = setInterval(function () {
        ++counter;
        let newValue = stageId + counter / 100;
        if (newValue <= maxId) {
          updateSliderValue(newValue);
        } else {
          if (mode.isPlaying) updateSliderValue(maxId);
          clearInterval(playInterval);
          playInterval = null;
        }
      }, ANIMATE_STAGE_MS / 100);
    } else if (mode.isPlaying) {
      // applyAnchorageStage(maxId, false, false);
      updateSliderValue(maxId);
      mode.isPlaying = false;
    }
  }
}

//#region Slider

function updateSliderValue(sliderValue) {
  if (sliderValue !== undefined) {
    updateSlider("#anchorageSlider", 1, sliderValue);
  }
}

function playSliderChanged(value) {
  let newValue = Math.floor(value);
  // console.log("anchor playSliderChanged", value, newValue);
  if (mode.currentStageId != newValue && !mode.isPlaying) {
    mode.currentStageId = newValue;
    applyAnchorageStage(mode.currentStageId);
  }
}

//#endregion

//#region Video

function generateVideo() {
  document.getElementById("anchorageSaveImg").style.display = "block";

  if (!videoScene) {
    videoScene = createVideoScene();
    // let container = viewer.renderer.domElement.parentElement;
    // container.appendChild(videoScene.renderer.domElement);

    let mType = getMimeType();
    let canvas = videoScene.renderer.domElement;
    let RecordRTC = require("recordrtc");
    videoRecorder = RecordRTC(canvas, {
      type: "canvas",
      mimeType: mType,
      disableLogs: true,
    });
    let mTypeArr = mType.split("/");
    videoExtension =
      mTypeArr.length && mTypeArr.length > 1 ? mTypeArr[1] : "webm";
  }

  vueApp.allItems.forEach((item) => {
    let itemMesh = viewer.get_model_mesh(item.id);
    let videoMesh = itemMesh.videoMesh;
    if (!itemMesh.videoMesh) {
      videoMesh = itemMesh.videoMesh = new THREE.Mesh(
        itemMesh.geometry.clone(),
        itemMesh.material.clone()
      );
      videoScene.add(videoMesh);
      videoMesh.model = item;
      videoMesh.mainMesh = itemMesh;
    }
    videoMesh.material.color = itemMesh.material.color;
    videoMesh.material.opacity = itemMesh.material.opacity;
    videoMesh.position.copy(itemMesh.position);
    videoMesh.rotation.copy(itemMesh.rotation);
    videoMesh.visible = itemMesh.visible;
  });
  console.log("generateVideo", videoScene);

  videoScene.camera.up.y = 1;
  videoScene.camera.up.x = 0;
  videoScene.camera.up.z = 0;

  videoScene.camera.position.copy(anchorData.cameraPoint);
  videoScene.camera.lookAt(anchorData.targetPoint);
  videoScene.camera.updateProjectionMatrix();

  let meshes1 = teeth1.map((t) => viewer.get_model_mesh(t.id));
  let meshes2 = teeth2.map((t) => viewer.get_model_mesh(t.id));
  let allMeshes = meshes1.concat(meshes2);
  videoScene.mixers = [];
  for (const mesh of allMeshes) {
    let videoMesh = mesh.videoMesh;
    let mixer = videoMesh.mixer;
    if (mixer) {
      mixer.stopAllAction();
      mixer.uncacheAction(mesh.anchorageClip, videoMesh);
      // mixer.uncacheClip(mesh.anchorageClip);
    }

    mixer = videoMesh.mixer = new THREE.AnimationMixer(videoMesh);
    let clipAction = mixer.clipAction(mesh.anchorageClip);
    // clipAction.setLoop(THREE.LoopOnce, 1);
    // clipAction.setDuration(ANIMATE_STAGE_SEC);
    // clipAction.setEffectiveTimeScale(1 / ANIMATE_STAGE_SEC);
    clipAction.play();
    videoScene.mixers.push(videoMesh.mixer);
  }

  videoRecorder.startRecording();
  setTimeout(() => {
    videoScene.mixers = [];
    videoRecorder.stopRecording(function (url) {
      let fileName = `anchorageVideo_${getFormattedDate(
        true
      )}.${videoExtension}`;
      saveFile(url, fileName);
      document.getElementById("anchorageSaveImg").style.display = "none";
    });
  }, ANIMATE_STAGE_MS);
}

function createVideoScene() {
  const isMobileOrTablet = mobileAndTabletCheck();
  let width = isMobileOrTablet ? 1280 : 1920;
  let height = isMobileOrTablet ? 720 : 1080;

  const scene = new THREE.Scene();
  scene.background = viewer.scene.background; //new THREE.Color("#EEF3FF");

  const renderer = new THREE.WebGLRenderer();
  renderer.setSize(width, height);
  scene.renderer = renderer;

  const camera = new THREE.PerspectiveCamera(45, width / height, 0.1, 1e4);
  scene.add(camera);
  scene.camera = camera;
  scene.camera.aspect = width / height;
  scene.camera.updateProjectionMatrix();

  addSceneLights(scene, camera);
  scene.clock = new THREE.Clock();
  scene.mixers = [];

  // renderer.setAnimationLoop(() => {
  //   if (scene.mixers && scene.mixers.length > 0) {
  //     const delta = scene.clock.getDelta();
  //     for (const mixer of scene.mixers) {
  //       mixer.update(delta);
  //     }
  //   }
  //   renderer.render(scene, camera);
  // });

  function animate() {
    if (scene.mixers && scene.mixers.length > 0) {
      const delta = scene.clock.getDelta();
      for (const mixer of scene.mixers) {
        mixer.update(delta);
      }
    }
    requestAnimationFrame(animate);
    renderer.render(scene, camera);
  }
  animate();
  return scene;
}

//#endregion

export {
  enterAnchorageAnimationMode,
  leaveAnchorageAnimationMode,
  applyAnchorageStage,
  switchAnchoragePlay,
  generateVideo,
};
